(function () {
  "use strict";

  function initMegaNavigation() {
    var dropdowns = Array.prototype.slice.call(document.querySelectorAll("[data-dropdown]"));
    if (!dropdowns.length) return;

    var desktopQuery = window.matchMedia("(min-width: 901px)");
    var navToggle = document.querySelector("[data-nav-toggle]");
    var closeTimers = new WeakMap();

    function clearCloseTimer(dropdown) {
      var timer = closeTimers.get(dropdown);
      if (timer) {
        window.clearTimeout(timer);
        closeTimers.delete(dropdown);
      }
    }

    function setOpen(dropdown, shouldOpen) {
      var toggle = dropdown.querySelector("[data-dropdown-toggle]");
      var menu = dropdown.querySelector("[data-dropdown-menu]");

      clearCloseTimer(dropdown);
      dropdown.classList.toggle("open", shouldOpen);

      if (toggle) toggle.setAttribute("aria-expanded", String(shouldOpen));
      if (menu) menu.setAttribute("aria-hidden", String(!shouldOpen));
    }

    function closeAll(except) {
      dropdowns.forEach(function (dropdown) {
        if (dropdown !== except) setOpen(dropdown, false);
      });
    }

    function scheduleClose(dropdown) {
      clearCloseTimer(dropdown);
      closeTimers.set(
        dropdown,
        window.setTimeout(function () {
          setOpen(dropdown, false);
        }, 150)
      );
    }

    dropdowns.forEach(function (dropdown) {
      var toggle = dropdown.querySelector("[data-dropdown-toggle]");
      var menu = dropdown.querySelector("[data-dropdown-menu]");

      if (menu) menu.setAttribute("aria-hidden", "true");
      if (!toggle) return;

      toggle.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        var willOpen = !dropdown.classList.contains("open");
        closeAll(dropdown);
        setOpen(dropdown, willOpen);
      });

      dropdown.addEventListener("mouseenter", function () {
        if (!desktopQuery.matches) return;
        clearCloseTimer(dropdown);
        closeAll(dropdown);
        setOpen(dropdown, true);
      });

      dropdown.addEventListener("mouseleave", function () {
        if (!desktopQuery.matches) return;
        scheduleClose(dropdown);
      });

      dropdown.addEventListener("focusin", function () {
        if (!desktopQuery.matches) return;
        clearCloseTimer(dropdown);
        closeAll(dropdown);
        setOpen(dropdown, true);
      });

      dropdown.addEventListener("focusout", function (event) {
        if (!desktopQuery.matches) return;
        if (!dropdown.contains(event.relatedTarget)) scheduleClose(dropdown);
      });

      if (menu) {
        menu.addEventListener("mouseenter", function () {
          clearCloseTimer(dropdown);
        });

        menu.addEventListener("mouseleave", function () {
          if (desktopQuery.matches) scheduleClose(dropdown);
        });
      }
    });

    document.addEventListener("click", function (event) {
      if (!event.target.closest("[data-dropdown]")) closeAll();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;

      var openDropdown = document.querySelector("[data-dropdown].open");
      closeAll();

      if (openDropdown) {
        var openToggle = openDropdown.querySelector("[data-dropdown-toggle]");
        if (openToggle) openToggle.focus();
        return;
      }

      if (navToggle && navToggle.getAttribute("aria-expanded") === "true") {
        navToggle.click();
        navToggle.focus();
      }
    });

    if (navToggle) {
      navToggle.addEventListener("click", function () {
        window.setTimeout(function () {
          var expanded = navToggle.getAttribute("aria-expanded") === "true";
          navToggle.setAttribute("aria-label", expanded ? "Close navigation" : "Open navigation");
          if (!expanded) closeAll();
        }, 0);
      });
    }

    function resetForViewport() {
      closeAll();

      if (desktopQuery.matches) {
        document.body.classList.remove("menu-open");
        if (navToggle) {
          navToggle.setAttribute("aria-expanded", "false");
          navToggle.setAttribute("aria-label", "Open navigation");
        }
      }
    }

    if (typeof desktopQuery.addEventListener === "function") {
      desktopQuery.addEventListener("change", resetForViewport);
    } else if (typeof desktopQuery.addListener === "function") {
      desktopQuery.addListener(resetForViewport);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMegaNavigation);
  } else {
    initMegaNavigation();
  }
})();
